// First-touch marketing attribution.
// captureAttribution() runs once on page load and remembers where the visitor
// came from (utm_* params, external referrer, landing path). It never
// overwrites an earlier capture, so the first channel that brought someone
// in gets the credit. sendAttribution() posts it to the server once after the
// user is signed in; the server only stores it for brand-new accounts.
import axios from "axios";
import config from "../config";

const KEY = "dmyor_attr";
const SENT_KEY = "dmyor_attr_sent";

export function captureAttribution() {
  try {
    if (typeof window === "undefined" || localStorage.getItem(KEY)) return;
    const params = new URLSearchParams(window.location.search);
    let referrer = document.referrer || "";
    try {
      if (referrer && new URL(referrer).hostname.endsWith("dmyor.com")) referrer = "";
    } catch (_) {
      referrer = "";
    }
    const attr = {
      source: params.get("utm_source") || params.get("ref_src") || "",
      medium: params.get("utm_medium") || "",
      campaign: params.get("utm_campaign") || "",
      content: params.get("utm_content") || "",
      referrer,
      landingPath: window.location.pathname + window.location.search,
      firstSeenAt: new Date().toISOString(),
    };
    localStorage.setItem(KEY, JSON.stringify(attr));
  } catch (_) {}
}

export function sendAttribution() {
  try {
    if (localStorage.getItem(SENT_KEY)) return;
    const raw = localStorage.getItem(KEY);
    const attr = raw ? JSON.parse(raw) : {};
    localStorage.setItem(SENT_KEY, "1");
    axios
      .post(`${config.apiUrl}/api/v1/me/attribution`, attr, { withCredentials: true })
      .catch(() => {});
  } catch (_) {}
}
